import api from './api';

export interface DealerBilling {
  dealer: {
    id: string;
    username: string;
    email: string;
  };
  lastMonth: {
    revenue: number;
    orderCount: number;
  };
  currentMonth: {
    revenue: number;
    orderCount: number;
  };
  total: {
    revenue: number;
    orderCount: number;
  };
}

export interface BillingData {
  period: {
    lastMonth: {
      start: string;
      end: string;
      label: string;
    };
    currentMonth: {
      start: string;
      end: string;
      label: string;
    };
  };
  dealers: DealerBilling[];
  totals: {
    lastMonth: number;
    currentMonth: number;
    overall: number;
  };
}

export const getBilling = async (): Promise<BillingData> => {
  const response = await api.get<BillingData>('/admin/billing');
  return response.data;
};
